import { render, staticRenderFns } from "./loadOtherDetail.vue?vue&type=template&id=3663b723&"
import script from "./loadOtherDetail.vue?vue&type=script&lang=js&"
export * from "./loadOtherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports